import { useCallback } from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Switch,
} from '@mui/material';
import type { AmtProcessConfig } from '../../utils/amtModdleDescriptor';
import { createEmptyProcessConfig } from '../../utils/amtModdleDescriptor';

interface ProcessConfigEditorProps {
  value: AmtProcessConfig | null;
  onChange: (value: AmtProcessConfig) => void;
}

export function ProcessConfigEditor({ value, onChange }: ProcessConfigEditorProps) {
  const processConfig = value || createEmptyProcessConfig();

  const handleToggle = useCallback(
    (_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange({ ...processConfig, returnChannelEnabled: checked });
    },
    [processConfig, onChange]
  );

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom>
        Prozesskonfiguration
      </Typography>

      <FormControlLabel
        control={
          <Switch
            checked={processConfig.returnChannelEnabled}
            onChange={handleToggle}
          />
        }
        label="Rueckkanal aktiviert"
      />

      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1 }}>
        {processConfig.returnChannelEnabled
          ? 'Buerger koennen Rueckfragen zu diesem Prozess an die Behoerde stellen.'
          : 'Kein Rueckkanal: Buerger erhalten nur eine Referenznummer ohne Kommunikationsmoeglichkeit.'}
      </Typography>
    </Box>
  );
}
